import React from 'react';

import type { Transaction } from 'types/api/transaction';

import { useI18n } from 'lib/contexts/i18n';

import type { StatusTagType } from './StatusTag';
import StatusTag from './StatusTag';

export interface Props {
  status: Transaction['status'];
  errorText?: string | null;
  isLoading?: boolean;
}

const TxStatus = ({ status, errorText, isLoading }: Props) => {
  const { t } = useI18n();

  if (status === undefined) {
    return null;
  }

  let text;
  let type: StatusTagType;

  switch (status) {
    case 'ok':
      text = t('common.success');
      type = 'ok';
      break;
    case 'error':
      text = t('common.failed');
      type = 'error';
      break;
    case null:
      text = t('common.pending');
      type = 'pending';
      break;
  }

  return <StatusTag type={ type } text={ text } errorText={ errorText } loading={ isLoading }/>;
};

export default TxStatus;
